export default {
  data: () => ({
    loadingChart: false,
    removeChartOutlier: false,
    enableChartMultiAxis: true,
  }),
  computed: {
    chartFilters() {
      return {
        multiAxis: this.enableChartMultiAxis,
        removeOutlier: this.removeChartOutlier,
      };
    },
  },
};
